import {Injectable, Injector} from '@angular/core';

import {
  HttpService,
} from 'projects/core/src/public-api';
import {Observable, Subject} from 'rxjs';
import {ProjectActivity} from '../../project-misc/data/project/activity/project-activity';
import {Any} from 'json2typescript';
import {RouteVehicle} from './route-vehicle';
import {ProjectStatus} from '../../project-misc/data/project/statuses/project-status';
import {ActivityForEdit} from '../../admin-panel/data/activityi-for-edit';
import {LogisticSuggestion} from './logistic-suggestion';

export interface SuggestionDay {
  title: string;
  activities: ProjectActivity[]
}

@Injectable({
  providedIn: 'root',
})
export class LogisticRoutesService extends HttpService {
  suggestionDndActive = false;
  logisticSuggestionChangesSubj = new Subject()
  serviceLogisticSuggestion: LogisticSuggestion;

  constructor(
    protected injector: Injector,
  ) {
    super(injector);
  }

  getVehicles(): Observable<RouteVehicle[]> {
    return this.getData(`/routing/vehicle/list`, RouteVehicle);
  }

  getDeliveryActivities(startDate: string, endDate: string): Observable<ProjectActivity[]> {
    return this.getData(`/project/activity/routing-list/${startDate}:${endDate}`, ProjectActivity);
  }

  updateVehicleRoute(carId: number, timeStamp: string, activityIds: number[]): Observable<RouteVehicle> {
    return this.postData(`/routing/vehicle/${carId}/calc-route`, {
      lastInteractionTime: timeStamp,
      activities: activityIds
    }, RouteVehicle);
  }

  unloadRoutes(activityIds: number[]): Observable<RouteVehicle> {
    return this.postData(`/routing/exclude-waypoints`, activityIds, RouteVehicle);
  }

  getDeliveryCars(): Observable<any[]> {
    return this.getData(`/routing/vehicle/list`, Any);
  }

  createVehicle(vehicle: RouteVehicle): Observable<RouteVehicle> {
    return this.postData(`/routing/vehicle/list`, vehicle, RouteVehicle);
  }

  deleteVehicle(vehicleId: number): Observable<null> {
    return this.deleteData(`/routing/vehicle/${vehicleId}`, null);
  }

  editVehicle(vehicle: RouteVehicle): Observable<RouteVehicle> {
    return this.putData(`/routing/vehicle/list`, vehicle, RouteVehicle);
  }

  moveWaypoint(vehicleId: number, activityId: number, pos: number): Observable<RouteVehicle> {
    return this.postData(`/routing/vehicle/${vehicleId}/move-waypoint`, {
      id: activityId,
      pos
    }, RouteVehicle);
  }

  sendSmsToUser(vehicleId: number): Observable<any[]> {
    return this.postData(`/routing/vehicle/${vehicleId}/send-route`, {}, Any);
  }

  getVehicleStatuses(): Observable<ProjectStatus[]> {
    return this.getData(`/dictionary-word/list/for-type/VEHICLE_STATUS`, ProjectStatus)
  }

  getVehicleActivityTypes(): Observable<ActivityForEdit[]> {
    return this.getData(`/activity/types/for-routing`, ActivityForEdit)
  }

  optimizeVehicle(vehicleId: number, activityIds: number[]): Observable<RouteVehicle> {
    return this.postData(`/routing/vehicle/${vehicleId}/optimize-route`, activityIds, RouteVehicle);
  }

  getSuggestions(startDate: string, endDate: string): Observable<LogisticSuggestion> {
    return this.getData(`/production-planning/suggestions/${startDate}:${endDate}`, LogisticSuggestion);
  }

  acceptLogistic(startDate: string, endDate: string): Observable<LogisticSuggestion> {
    return this.putData(`/production-planning/suggestions/${startDate}:${endDate}/accept`, {}, LogisticSuggestion);
  }

  refreshLogistic(startDate: string, endDate: string): Observable<LogisticSuggestion> {
    return this.putData(`/production-planning/suggestions/${startDate}:${endDate}/refresh`, {}, LogisticSuggestion);
  }
}
